const FocusViewIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M0.625 6.25V1.875C0.625 1.54348 0.756696 1.22554 0.991117 0.991117C1.22554 0.756696 1.54348 0.625 1.875 0.625H6.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 0.625H18.125C18.4565 0.625 18.7745 0.756696 19.0089 0.991117C19.2433 1.22554 19.375 1.54348 19.375 1.875V6.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.375 13.75V18.125C19.375 18.4565 19.2433 18.7745 19.0089 19.0089C18.7745 19.2433 18.4565 19.375 18.125 19.375H13.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 19.375H1.875C1.54348 19.375 1.22554 19.2433 0.991117 19.0089C0.756696 18.7745 0.625 18.4565 0.625 18.125V13.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8.125C11.0355 8.125 11.875 7.28553 11.875 6.25C11.875 5.21447 11.0355 4.375 10 4.375C8.96447 4.375 8.125 5.21447 8.125 6.25C8.125 7.28553 8.96447 8.125 10 8.125Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 10.625H10.625C11.6196 10.625 12.5734 11.0201 13.2767 11.7233C13.9799 12.4266 14.375 13.3804 14.375 14.375H5.625C5.625 13.3804 6.02009 12.4266 6.72335 11.7233C7.42661 11.0201 8.38044 10.625 9.375 10.625Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FocusViewIcon;
